import { useContext } from 'react';
import FinancialInstitutionContext from 'src/contexts/financialInstitution/financialInstitutionContext';

const useFinancialInstitution = () => useContext(FinancialInstitutionContext);

export default useFinancialInstitution;
